var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAfter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_69327",
    "data-name": "Group 69327",
    xmlns: "http://www.w3.org/2000/svg",
    width: 93.102,
    height: 93.102,
    viewBox: "0 0 93.102 93.102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3064",
    cx: 46.551,
    cy: 46.551,
    r: 46.551,
    fill: "#1891e5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_57470",
    d: "M40.519,76.178q1.338-.26,2.659-.6,2.24-.624,4.41-1.47t4.25-1.894A46.548,46.548,0,0,0,55.877,69.9q1.957-1.257,3.781-2.7a46.547,46.547,0,0,0,3.5-3.076q1.667-1.621,3.167-3.4a46.55,46.55,0,0,0,2.819-3.705q1.314-1.919,2.432-3.963t2.023-4.19q.908-2.144,1.6-4.372.59-1.947,1.008-3.94L48.55,12.891A25.215,25.215,0,1,0,12.895,48.554Z",
    transform: "translate(15.828 15.833)",
    fill: "#006ebb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_57471",
    d: "M27.232,2A25.226,25.226,0,1,1,9.4,9.395,25.128,25.128,0,0,1,27.232,2ZM38.718,19.464a1.953,1.953,0,0,0-1.015.4L23.535,30.5l-6.569-6.569c-1.425-1.484-4.227,1.318-2.743,2.743l7.758,7.758a2.006,2.006,0,0,0,2.531.182L40.029,22.972a2.048,2.048,0,0,0-1.114-3.508,1.941,1.941,0,0,0-.2,0Z",
    transform: "translate(19.322 19.332)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfter);
export default __webpack_public_path__ + "static/media/after.836c9f67.svg";
export { ForwardRef as ReactComponent };